/**
 * 公共API
 */
var request = require('sync-request');
var uuid = require('node-uuid');

let UUID=localStorage.getItem("sessionId")
if(UUID===undefined||UUID===null){
	UUID=uuid.v4()
	localStorage.setItem("sessionId",UUID)
}
console.log(UUID)

/**
 * 验证码
 * @returns {*}
 */
export async function captcha() {


	let url = this.$global.url+'/captcha/?id='+UUID;
	console.log(url)
	console.log(UUID)
	let ll = request('GET', url);
	let ll_res = JSON.parse(ll.getBody('utf8'));
	return ll_res

}
/**
 * 验证码验证
 * @returns {*}
 */
export async function captchaVerify(data) {

	var res = await request('POST', this.$global.url+'/captcha/verify?id='+UUID, {
		json: data,
	});
	return JSON.parse(res.getBody('utf8'))
}
